package floris.graphics.models.domain.models

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.category.CategoryDto

data class Category(
    val id: String = "",
    val name: String = "",
    val category: Category? = null,
    val subCategories: List<Category>? = null,
    override val createdAt: String = "",
    override val updatedAt: String = "",
) : DateAble


//TODO: test this out with triple nested categories!!
fun Category.toDto(): CategoryDto = CategoryDto(
    id = this.id,
    name = this.name,
    subCategories = subCategories?.map { it.toDto() },
    category = this.category?.toDto(),
    createdAt = this.createdAt,
    updatedAt = this.updatedAt
)

fun CategoryDto.toCategory(): Category = Category(
    id = id,
    name = name,
    subCategories = subCategories?.map { it.toCategory() },
    category = category?.toCategory(),
    createdAt = createdAt,
    updatedAt = updatedAt
)